/**
 * WalterGO Umami Tracker — globale Helper + SEO-Landing-Marker
 * Spec: analytics/tracking-spec.md §1.2, §3.8, §4.1–4.3
 *
 * wgTrack(name, data?)         — Safe-Wrapper für umami.track
 * wgTrackVisibility(sel, name) — IntersectionObserver-Helper für View-Events
 * seo.landing (IIFE)           — 1x pro Session: traffic_source + search_engine
 */
(function () {
  'use strict';

  window.wgTrack = function (eventName, eventData) {
    if (!window.umami || typeof window.umami.track !== 'function') return;
    try {
      if (eventData) {
        window.umami.track(eventName, eventData);
      } else {
        window.umami.track(eventName);
      }
    } catch (e) {
      // Stillschweigend ignorieren — Tracking darf die Seite nie crashen.
    }
  };

  window.wgTrackVisibility = function (selector, eventName, threshold) {
    if (!('IntersectionObserver' in window)) return;
    var t = typeof threshold === 'number' ? threshold : 0.5;
    var nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;
    nodes.forEach(function (el) {
      if (el.dataset.wgTracked === '1') return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && el.dataset.wgTracked !== '1') {
            el.dataset.wgTracked = '1';
            window.wgTrack(eventName);
            obs.unobserve(el);
          }
        });
      }, { threshold: t });
      obs.observe(el);
    });
  };

  // SEO-Landing-Marker — 1x pro Session
  (function () {
    var SESSION_KEY = 'wg_seo_marked';
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return;
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {
      return; // SessionStorage blockiert (Privacy-Mode) — kein SEO-Event
    }

    var ref = document.referrer;
    var params = new URLSearchParams(window.location.search);
    var trafficSource = 'direct';
    var searchEngine = null;
    var referrerId = null;

    var hasUtm = params.get('utm_source');
    var hasGclid = params.get('gclid');
    var hasFbclid = params.get('fbclid');
    var refParam = params.get('ref');

    // 1. Partner-Link höchste Priorität (Affiliate-Programm).
    //    refParam = SAP-Partner-ID aus Orthopädie-Walter-CRM. KEIN Endkunden-PII.
    //    Regex blockt versehentliche Tokens (Email-Hashes mit @, lange Strings).
    if (refParam && /^[A-Za-z0-9_-]{1,16}$/.test(refParam)) {
      trafficSource = 'partner';
      referrerId = refParam;
    }
    // 2. UTM / Ads-Click
    else if (hasUtm || hasGclid || hasFbclid) {
      var medium = (params.get('utm_medium') || '').toLowerCase();
      trafficSource = (medium === 'cpc' || medium === 'paid' || hasGclid || hasFbclid) ? 'paid' : 'referral';
    }
    // 3. Referrer-Domain-Klassifikation
    else if (ref) {
      try {
        var host = new URL(ref).hostname.replace(/^www\./, '');
        if (/google\./.test(host)) { trafficSource = 'organic'; searchEngine = 'google'; }
        else if (/bing\./.test(host)) { trafficSource = 'organic'; searchEngine = 'bing'; }
        else if (/duckduckgo\./.test(host)) { trafficSource = 'organic'; searchEngine = 'duckduckgo'; }
        else if (/ecosia\./.test(host)) { trafficSource = 'organic'; searchEngine = 'ecosia'; }
        else if (/(facebook|instagram|tiktok|twitter|x\.com|linkedin|pinterest|youtube)\./.test(host)) {
          trafficSource = 'social';
        } else {
          trafficSource = 'referral';
        }
      } catch (e) {}
    }

    function fire() {
      var payload = { traffic_source: trafficSource };
      if (searchEngine) payload.search_engine = searchEngine;
      if (referrerId) payload.referrer_id = referrerId;
      window.wgTrack('seo.landing', payload);
    }

    // Auf umami warten (defer-Load) — kurzes Poll, gibt nach 5s auf.
    if (window.umami) {
      fire();
    } else {
      var tries = 0;
      var iv = setInterval(function () {
        if (window.umami || tries++ > 50) {
          clearInterval(iv);
          if (window.umami) fire();
        }
      }, 100);
    }
  })();
})();
